const API_PORT = location.port;
export const API_URL_HOST = location.hostname + (API_PORT ? ':' + API_PORT : '');

export const API_URL_WS_ADMIN = 'wss://' + API_URL_HOST + '/v1/ws/dashboard/admin-console';
export const API_URL_WS = 'wss://' + API_URL_HOST + '/v1/ws/dashboard/console';
export const API_URL_HTTP = 'https://' + API_URL_HOST;
